import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// import moment from 'moment';

import { user } from 'services';
// import { deletePlate } from 'services/payments-service';
import { TableExt, TableInfo, Confirm, themes, GridBox, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import UserForm from './forms/user-form';
import { getTableParams } from './grid.params';

export const UserGrid = (props) => {
  const { count, entries, className, theme, getXlsAction, clientId, updateEntry } = props;
  //const interface1 = props.interface;
  const [showForm, setShowForm] = useState('');
  const [row, setRow] = useState({});
  const [confirm, setConfirm] = useState(null);

  const { t } = useTranslation();

  /**
   * close confirm
   */
  const closeConfirm = () => {
    setConfirm(null);
  };

  /**
   * delete item
   */
  // const delItem = (id) => {
  //   deletePlate(id).then(() => {
  //     props.getEntries({ offset: 0 }, null, true);
  //     closeConfirm();
  //   });
  // };

  // actions
  const addItemAction = () => {
    setRow({});
    setShowForm('addForm');
  };

  const editItemAction = (row) => {
    setRow(row);
    setShowForm('editForm');
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const rightEdit = user.haveRight('users.update');
  // const rightDel = user.haveRight('users.delete');
  const rightAdd = user.haveRight('users.add');
  const actions = [];
  // if (rightEdit) {
  //   actions.push({ title: 'Редактировать', action: editItemAction });
  // }
  // if (rightDel) {
  //   actions.push({ title: t('buttons.Удалить'), action: delItemAction });
  // }

  // top actions
  const topActions = [];
  if (rightAdd) {
    topActions.push({ title: t('buttons.Добавить'), icon: 'fa-plus', theme: themes.blue, action: addItemAction });
  }
  if (count) {
    getXlsAction(topActions);
  }

  const initial = showForm === 'addForm' ? {} : { ...row };
  if (initial.phone) {
    let phone = initial.phone;
    if (phone[0] === '+') {
      phone = phone.substring(1);
      initial.phone = phone;
    }
  }
  const tableParams = useMemo(() => getTableParams(t), []);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('user', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Пользователи')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        clientId={clientId}
        onRowClick={rightEdit ? editItemAction : undefined}
        {...restTableParams}
        fields={fields}
        updateEntry={updateEntry}
      />

      {confirm && <Confirm {...confirm} />}

      {showForm && <UserForm type={showForm} close={() => setShowForm('')} id={row.id} refresh={props.refresh} initialValues={initial} />}

    </GridBox>
  );
};
